// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-title {
  text-align: center;
  font-size: 16px;
}

.btnIcon {
  text-align: center;
}

#title {
  display: flex;
  align-items: center;
}

ion-icon {
  cursor: pointer;
}

@media screen and (max-width: 320px) {
  ion-title {
    font-size: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/formules/formule-form/formule-form.component.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;AAAJ;;AAIA;EACI,eAAA;AADJ;;AAMA;EACQ;IACI,eAAA;EAHV;AACF","sourcesContent":["\r\nion-title{\r\n    text-align: center;\r\n    font-size: 16px;\r\n}\r\n\r\n.btnIcon {\r\n    text-align: center;\r\n  }\r\n\r\n#title{\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n\r\nion-icon{\r\n    cursor : pointer;\r\n}\r\n\r\n\r\n\r\n@media screen and (max-width : 320px){\r\n        ion-title{\r\n            font-size: 15px;\r\n        }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
